import React from "react";
import ContactAndFooter from "../../../../components/ContactAndFooter.js";
import "./style.scss";

export default function PageFooter() {
  return (
    <div style={{ paddingBottom: 40, width: "100%" }}>
      <ContactAndFooter />
    </div>
  );
}
